import normalize from "json-api-normalizer";
import store from "@/store/index";

import BaseService from "./BaseService";

export default {
  load() {
    return BaseService.get("symptoms")
      .then(response => {
        store.dispatch("symptom/set", normalize(response.data).symptoms);
      })
      .catch(errors => Promise.reject(errors));
  },

  create(values) {
    return BaseService.post("symptoms", "symptoms", values)
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  },

  update(values) {
    return BaseService.patch("symptoms", `symptoms/${values.id}`, values)
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  },

  delete(id) {
    return BaseService.delete(`symptoms/${id}`)
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  }
};
